//

import { mapGetters } from "vuex";
import ExpressionHandler from "../../Control/ExpressionHandler/ExpressionHandler.vue";

export default {
    name: "DoWhileHandler",
    computed: {
        ...mapGetters("smartContractDesigner", ["selectedPluginData"])
    },
    components: {
        ExpressionHandler
    },
    props: {
        readonly: Boolean
    },
    data() {
        return { expressionValue: null };
    },
    watch: {
        expressionValue(val) {
            this.$store.commit("smartContractDesigner/setChangesOnCurrentData", this.value);
        }
    },
    mounted() {
        this.expressionValue = this.selectedPluginData && this.selectedPluginData.condition ? this.selectedPluginData.condition : "";
    }
};
